module.exports = __webpack_public_path__ + "static/media/rsrcmtr_128.42fe4d77.ico";